/**
 * Tone mapping shared by the offline renderer (background plates), the CPU compositor and the
 * GLSL shaders (`webgl/shaders.ts`) — all three must stay in sync.
 */

/** ACES filmic approximation (Narkowicz 2015) applied per channel to exposed linear values. */
export function acesFilm(x: number): number {
  const v = (x * (2.51 * x + 0.03)) / (x * (2.43 * x + 0.59) + 0.14);
  return v < 0 ? 0 : v > 1 ? 1 : v;
}

export function linearToSrgb(c: number): number {
  return c <= 0.0031308 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055;
}

export function srgbToLinear(c: number): number {
  return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
}

/** Exposed linear radiance → display byte. */
export function displayByte(linear: number, exposure: number): number {
  return Math.round(linearToSrgb(acesFilm(linear * exposure)) * 255);
}

const SRGB_TO_LINEAR_LUT = new Float32Array(256);
for (let i = 0; i < 256; i++) SRGB_TO_LINEAR_LUT[i] = srgbToLinear(i / 255);
export { SRGB_TO_LINEAR_LUT };
